(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alcott-testimonials"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new WeakMap();

  class AlcottQuotesSlider {
    constructor(container) {
      this.container = container;
      this.slider = container.querySelector('.quotes-slider');
      this.slides = Array.from(
        container.querySelectorAll('.quotes-slide')
      );

      if (!this.slider || this.slides.length === 0) {
        return;
      }

      this.speed = Number(this.slider.dataset.speed) || 4000;
      this.timer = null;

      const visibleIndex = this.slides.findIndex((slide) =>
        slide.classList.contains('quotes-slide--visible')
      );

      this.currentSlide = visibleIndex >= 0 ? visibleIndex : 0;

      this.showSlide(this.currentSlide);
      this.start();
    }

    showSlide(index) {
      this.currentSlide = index;

      this.slides.forEach((slide, slideIndex) => {
        const isVisible = slideIndex === index;

        slide.classList.toggle(
          'quotes-slide--visible',
          isVisible
        );

        slide.setAttribute(
          'aria-hidden',
          String(!isVisible)
        );
      });
    }

    start() {
      this.stop();

      if (this.slides.length <= 1) {
        return;
      }

      if (
        window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches
      ) {
        return;
      }

      this.timer = window.setInterval(() => {
        const nextSlide =
          (this.currentSlide + 1) % this.slides.length;

        this.showSlide(nextSlide);
      }, this.speed);
    }

    stop() {
      if (this.timer !== null) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    selectBlock(slide) {
      const index = this.slides.indexOf(slide);

      if (index === -1) {
        return;
      }

      this.stop();
      this.showSlide(index);
    }

    destroy() {
      this.stop();
    }
  }

  function findContainers(root) {
    const containers = [];

    if (
      root instanceof Element &&
      root.matches('[data-section-type="quotes-section"]')
    ) {
      containers.push(root);
    }

    if (root.querySelectorAll) {
      root
        .querySelectorAll(
          '[data-section-type="quotes-section"]'
        )
        .forEach((container) => {
          containers.push(container);
        });
    }

    return containers;
  }

  function initialize(root = document) {
    findContainers(root).forEach((container) => {
      if (!instances.has(container)) {
        instances.set(
          container,
          new AlcottQuotesSlider(container)
        );
      }
    });
  }

  function destroy(root) {
    findContainers(root).forEach((container) => {
      const instance = instances.get(container);

      if (instance) {
        instance.destroy();
        instances.delete(container);
      }
    });
  }

  initialize(document);

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initialize(event.target);
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      destroy(event.target);
    }
  );

  document.addEventListener(
    'shopify:block:select',
    (event) => {
      const slide = event.target.closest('.quotes-slide');

      if (!slide) {
        return;
      }

      const container = slide.closest(
        '[data-section-type="quotes-section"]'
      );

      const instance =
        container && instances.get(container);

      if (instance) {
        instance.selectBlock(slide);
      }
    }
  );

  document.addEventListener(
    'shopify:block:deselect',
    (event) => {
      const container = event.target.closest(
        '[data-section-type="quotes-section"]'
      );

      const instance =
        container && instances.get(container);

      if (instance) {
        instance.start();
      }
    }
  );
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
